module.exports = __webpack_public_path__ + "img/step-one-icon.777e89e9.jpg";